import { BorderStyle, convertInchesToTwip, HeadingLevel, ShadingType } from 'docx';

// A4 page (docx default) — keep in sync with generateDocumentProperties page.size
export const pageWidth = 11906;
export const pageHeight = 16838;
export const pageMargin = {
  top: 780,
  right: 820,
  bottom: 780,
  left: 1170
};
export const tableFullWidth = pageWidth - pageMargin.left - pageMargin.right;
export const leftColumnWidth = Math.round(tableFullWidth * 0.75); // 75% of the table width
export const rightColumnWidth = tableFullWidth - leftColumnWidth;

// Aliases kept for older call sites
export const headerColumnWidth = leftColumnWidth;
export const contentColumnWidth = rightColumnWidth;
export const projectNameColumnWidth = tableFullWidth;
export const logoColumnWidth = 1500;
export const borders = {
  top: {
    style: BorderStyle.SINGLE,
    size: 1,
    color: '666E7E'
  },
  bottom: {
    style: BorderStyle.SINGLE,
    size: 1,
    color: '666E7E'
  },
  left: {
    style: BorderStyle.SINGLE,
    size: 1,
    color: '666E7E'
  },
  right: {
    style: BorderStyle.SINGLE,
    size: 1,
    color: '666E7E'
  }
};
export const bordersInvisible = {
  top: {
    style: BorderStyle.NONE,
    size: 4,
    color: '#FFFFFF'
  },
  bottom: {
    style: BorderStyle.NONE,
    size: 4,
    color: '#FFFFFF'
  },
  left: {
    style: BorderStyle.NONE,
    size: 4,
    color: '#FFFFFF'
  },
  right: {
    style: BorderStyle.NONE,
    size: 4,
    color: '#FFFFFF'
  }
};
export const sideBorders = {
  top: {
    style: BorderStyle.NONE,
    size: 0,
    color: 'FFFFFF'
  },
  bottom: {
    style: BorderStyle.NONE,
    size: 0,
    color: 'FFFFFF'
  },
  left: {
    style: BorderStyle.SINGLE,
    size: 1,
    color: '#5CD2FF'
  },
  right: {
    style: BorderStyle.SINGLE,
    size: 1,
    color: '#5CD2FF'
  }
};

// Basically background color

export const shading = {
  fill: '#5CD2FF',
  type: ShadingType.SOLID,
  color: '#5CD2FF'
};
export const tableMargins = {
  top: convertInchesToTwip(0.01),
  bottom: convertInchesToTwip(0.08),
  right: convertInchesToTwip(0.05),
  left: convertInchesToTwip(0.08)
};
export const mainTextStyles = {
  font: 'Franklin Gothic Book',
  size: 20,
  color: '666E7E'
};
export const smallTextStyles = {
  font: 'Franklin Gothic Book',
  size: 14,
  color: '666E7E'
};
export const italicTextStyles = {
  font: 'Franklin Gothic Book',
  size: 16,
  color: '666E7E',
  italics: true
};
export const grayTitlesMainNotBold = {
  font: 'Franklin Gothic Book',
  size: 24,
  color: '666E7E'
};
export const grayTitlesMain = {
  font: 'Franklin Gothic Book',
  size: 24,
  color: '666E7E',
  bold: true
};
export const grayTitlesMainBlue = {
  font: 'Franklin Gothic Book',
  size: 24,
  color: '00AEEF',
  bold: true
};
export const grayTitlesSmall = {
  font: 'Franklin Gothic Book',
  size: 20,
  color: '666E7E'
};
export const blueTitlesSmall = {
  font: 'Georgia',
  size: 24,
  color: '00AEEF',
  bold: true
};
export const bookmarkStyle = {
  font: 'Georgia',
  size: 32,
  color: '00AEEF',
  bold: true
};
export const bookmarkStyle2 = {
  font: 'Franklin Gothic Book',
  size: 24,
  color: '00AEEF',
  bold: true
};
export const bookmarkParagraphOptions = {
  heading: HeadingLevel.HEADING_1,
  spacing: {
    before: 500,
    after: 300
  },
  indent: {
    left: 0
  }
};
export const bookmarkParagraphOptions2 = {
  heading: HeadingLevel.HEADING_1,
  spacing: {
    before: 500,
    after: 300
  }
};
export const mainParagraphOptions = {
  spacing: {
    before: 300,
    after: 200
  }
};